<template>
  <div div class="align-items-center login">
    <div>
      <b-navbar
        type="dark"
        class="nav-up"
        toggleable="md"
        style="height: 35px"
      ></b-navbar>
      <b-navbar toggleable="md" class="nav-down" style="height: 40px">
        <img
          src="/images/logo1.svg"
          style="height: 290px"
          alt="FGA"
          class="center"
        />
      </b-navbar>
    </div>
    <Titulo titulo="Descarga de certificados proveedores" />
    <div class="margin-cambiar-pass">
      <b-row>
        <b-col cols="12" md="6">
          <div class="panel1">
            <b-form @submit.prevent="onSubmit" @reset="onReset">
              <div>
                <h3 class="color-secundary">Consulta de certificados</h3>
                <p class="mb-4 text-justify">
                  1. Digita el NIT de tu empresa sin dígito de verificación
                  <br />
                  2. Acepta los términos y condiciones <br />
                  3. Presiona el botón consultar
                </p>
              </div>
              <b-form-group label="Nit" label-for="nit" :label-cols="2">
                <b-form-input
                  id="nit"
                  type="text"
                  v-model="nit"
                  required
                ></b-form-input>
                <b-form-checkbox v-model="acceptTerms"
                  >Acepto términos y condiciones</b-form-checkbox
                >
              </b-form-group>

              <div class="text-right">
                <b-button
                  class="button-carga"
                  style="margin: 2% 2% 2% 2%"
                  type="reset"
                  >Borrar</b-button
                >
                <b-button
                  class="button-carga"
                  style="margin: 2% 0% 2% 2%"
                  type="submit"
                  :disabled="loading || !acceptTerms"
                  >Consultar</b-button
                >
              </div>
            </b-form>
            <div
              class="container d-flex align-items-center justify-content-center"
            >
              <img
                v-if="loading"
                class="loading"
                src="@/assets/images/loader.gif"
                alt
              />
            </div>
            <br />
            <div class="recomen-cambio-pass p-4">
              <b-row>
                <b-col>
                  <div class="ancho-recomendaciones">
                    <b class="color-secundary" style="font-size: 24px">
                      <b-img
                        src="/images/pages/novedades.svg"
                        height="60"
                        class="mr-2"
                      ></b-img>
                      <br />Terminos y condiciones
                    </b>
                    <br />
                    <br />
                    Para descargar términos y condiciones
                    <a href="#" id="enlaceTerminos" @click="descargarTerminos()"
                      >haz clic aquí</a
                    >
                    <br />
                  </div>
                </b-col>
              </b-row>
              <br />
              <div
                class="container d-flex align-items-center justify-content-center"
              >
                <img
                  v-if="loading_terminos"
                  class="loading"
                  src="@/assets/images/loader.gif"
                  alt
                />
              </div>
            </div>
          </div>
        </b-col>

        <!-- Panel Derecho -->
        <b-col cols="12" md="6">
          <div>
            <h3 class="color-secundary">Descarga de certificados</h3>
            <p class="mb-4 text-justify">
              1. Seleccione uno de los certificados de la lista <br />
              2. Presiona el botón descargar
            </p>
          </div>
          <table-component
            :data="data"
            @click-event="clickEvent"
            :dataLength="data.length"
          >
            <table-column
              slot="label"
              :label="'Nombre'"
              v-bind:value="'nombre'"
              customClass="text-center"
            ></table-column>
            <table-column slot="label" :label="'Acciones'" :icon="'fa'">
              <template
                slot="icon"
                :icon="'fa fa-download'"
                :class="'btn btn-sm btn-info'"
                :slug="'descargar'"
                :tooltip="'Descargar'"
              ></template>
            </table-column>
          </table-component>
        </b-col>
      </b-row>
    </div>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <footer class="footer-container">
      <div class="foot-login">
        <!-- Ultima linea -->
        <b-row class="foot">
          <b-col cols="12" md="8" class="mb-2 ml-4 text-left">
            <div class="mb-3 ml-5">
              &nbsp;
              <br />FGA - Todos los derechos reservados
            </div>
          </b-col>
          <b-col cols="12" md="3" class="mb-2">
            <div>
              &nbsp;
              <br />Visite nuestras redes
              <a
                href="https://www.linkedin.com/company/fga-fondo-de-garantias"
                class="m-3"
                target="_blank"
                data-toggle="tooltip"
                title="LinkedIn"
              >
                <i class="fa fa-linkedin fa-2x"></i>
              </a>
              <a
                href="https://www.instagram.com/fgafondodegarantias/"
                target="_blank"
                data-toggle="tooltip"
                title="Instragram"
              >
                <i class="fa fa-instagram fa-2x"></i>
              </a>
              <a
                href="https://www.facebook.com/FGAFondodeGarantias"
                class="m-3"
                target="_blank"
                data-toggle="tooltip"
                title="Facebook"
              >
                <i class="fa fa-facebook fa-2x"></i>
              </a>
              <a
                href="https://www.youtube.com/user/FGAFondoGarantias"
                target="_blank"
                data-toggle="tooltip"
                title="YouTube"
              >
                <i class="fa fa-youtube-play fa-2x"></i>
              </a>
            </div>
          </b-col>
        </b-row>
      </div>
    </footer>
  </div>
</template>

<script>
import FileSaver from "file-saver";
export default {
  name: "CambioPassword",
  data() {
    return {
      selectPass: "",
      value: 95,
      max: 100,
      nit: null,
      loading: false,
      loading_terminos: false,
      acceptTerms: false,
      data: [],
    };
  },
  components: {
    Titulo: () => import("@/containers/layout/Titulo.vue"),
    SelectComponet: () => import("@/components/form/Select.vue"),
    TableComponent: () => import("@/components/table/TableComponent"),
    TableColumn: () => import("@/components/table/TableColumn"),
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      try {
        let response = await this.$store.state.api
          .get("proveedores/consultar", {
            params: {
              nit: this.nit,
            },
          })
          .then((response) => {
            this.data = response.data;
            this.loading = false;
          })
          .catch((err) => {
            this.$toasted.show(err.response.data.message, {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
            this.loading = false;
          });
      } catch (err) {
        console.log(err);
      }
    },
    onReset(evt) {
      this.data = [];
    },
    async clickEvent(data, slug) {
      switch (slug) {
        case "descargar":
          try {
            let response = await this.$store.state.api.post(
              "proveedores/descargar",
              {
                nombre: data.nombre,
              },
              { responseType: "arraybuffer" }
            );
            var blob = new Blob([response.data], {
              type: "application/pdf;charset=utf-8",
            });
            FileSaver.saveAs(blob, data.nombre);
            this.$toasted.show("Certificado descargado correctamente", {
              theme: "toasted-primary",
              position: "top-right",
              duration: 10000,
            });
          } catch (err) {
            console.log(err);
          }
          break;
        default:
          break;
      }
    },
    async descargarTerminos() {
      try {
        this.loading_terminos = true;
        let response = await this.$store.state.api.post(
          "proveedores/descargar",
          {
            nombre: "TerminosCondiciones.pdf",
          },
          { responseType: "arraybuffer" }
        );
        var blob = new Blob([response.data], {
          type: "application/pdf;charset=utf-8",
        });
        FileSaver.saveAs(blob, "TerminosCondiciones.pdf");
        this.$toasted.show("Archivo descargado correctamente", {
          theme: "toasted-primary",
          position: "top-right",
          duration: 10000,
        });
        this.loading_terminos = false;
      } catch (err) {
        this.loading_terminos = false;
        console.log(err);
      }
    },
  },
  mounted() {
    //
  },
};
</script>
<style>
.footer-container {
  position: fixed;
  bottom: 0;
  width: 100%;
  background-color: #ffffff; /* Puedes ajustar el color de fondo según tus preferencias */
}

.footer-image {
  width: 100%;
  height: auto;
  display: block;
}
</style>